<template>
    <div class="my-4">
        <div class="relative h-[56px] bg-white rounded" v-if="hours == 'loading'">
            <v-spa-loader></v-spa-loader>
        </div>
        <div v-if="hours && hours !== 'loading'">
            <div class="px-4 py-2 mt-4 bg-white border-l-4 border-red-600 rounded" v-if="hours.planned > hours.available">
                <div class="flex items-center">
                    <i class="mr-6 text-xl text-red-600 fal fa-exclamation-circle"></i>
                    <span class="text-sm font-thin text-gray-600">
                        <p>
                            {{ $t('modals.activity.user_week_hours.higher', {
                                planned: hours.planned_formatted,
                                available: hours.available_formatted,
                            }) }}
                        </p>
                    </span>
                </div>
            </div>
            <div class="mt-4 py-2 px-4 bg-white border-l-4 border-[#54b738] rounded" v-else>
                <div class="flex items-center">
                    <i class="mr-6 text-[#54b738] text-xl fal fa-check-circle"></i>
                    <span class="text-sm font-thin text-gray-600">
                        <p>
                            {{ $t('modals.activity.user_week_hours.ok', {
                                planned: hours.planned_formatted,
                                available: hours.available_formatted,
                            }) }}
                        </p>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            form: {
                required: true
            },
            activity: {
                required: true
            }
        },
        data() {
            return {
                hours: null
            }
        },
        methods: {
            async get()
            {
                if ( ! this.form.user ) {
                    this.hours = null;
                    return;
                }

                this.hours = 'loading';

                let data = {
                    activity_id: this.activity ? this.activity.id : null,
                    start: `${this.form.day} ${this.form.starts_at}:00`,
                    end: `${this.form.day} ${this.form.ends_at}:00`,
                    user: this.form.user.id
                };

                let {planned, available} = await this.$store.dispatch('getUserWeekHoursPlanned', data);
                
                this.hours = {
                    planned: planned,
                    planned_formatted: window.timeToHoursAndMinutes(planned),
                    available: available,
                    available_formatted: window.timeToHoursAndMinutes(available),
                };
            }
        },
        created()
        {
            this.get();
        }
    }
</script>